import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class AiEmployee extends MongoEntity {
  static override _class = 'AiEmployee';
  static override _collectionName = 'ai_employees';

  @Field(type => String) userId!: string;
  @Field(type => String) name!: string;
  @Field(type => String) role!: string;
  @Field(type => String) company!: string;
  @Field(type => String) communicationStyle!: string;
  // The sign-off used on email steps.
  @Field(type => String) signOff!: string;
  // The sign-off used on LinkedIn DM steps. Empty means "reuse the email one".
  // Connection requests deliberately carry no sign-off, so neither applies there.
  @Field(type => String) linkedinSignOff!: string;
  @Field(type => Boolean) isDefault!: boolean;
  @Field(type => String) createdAt!: string;
}
